import { connect } from 'react-redux';

import NotificationBar from '../../components/NotificationBar';

const mapStateToProps = state => ({
  notStarted: state.notificationBar.notStarted,
});

export default connect(mapStateToProps)(NotificationBar);



// WEBPACK FOOTER //
// ./src/features/NotificationBar/index.js